import React from "react";
import { Text, View } from "react-native";
import {
  formatMetric,
  MockGrain,
  MockMetric,
} from "./LocationSummaryV2MockData";
import { v2Styles as styles } from "./LocationSummaryV2.styles";
import { ColumnWidths } from "./LocationSummaryV2Table.shared";

interface MetricColumn {
  key: MockMetric;
  label: string;
}

interface Props {
  grains: MockGrain[];
  metrics: readonly MetricColumn[];
  totals: Record<string, number>;
  columnWidths: ColumnWidths;
}

const LocationSummaryTotalRow: React.FC<Props> = ({
  grains,
  metrics,
  totals,
  columnWidths,
}) => {
  return (
    <View style={[styles.tableRow, styles.totalRow, { width: "100%" }]}>
      {grains.map((grain, index) => (
        <Text
          key={grain}
          style={[
            styles.cell,
            { width: columnWidths.grain, fontWeight: "700" },
          ]}
        >
          {index === 0 ? "Total" : ""}
        </Text>
      ))}
      {metrics.map((metric) => (
        <Text
          key={metric.key}
          style={[
            styles.cell,
            styles.metricCell,
            styles.valueCell,
            { width: columnWidths.metric, fontWeight: "700" },
          ]}
        >
          {formatMetric(totals[metric.key], metric.key)}
        </Text>
      ))}
    </View>
  );
};

export default LocationSummaryTotalRow;
